import {useNumberOfItems} from "../../hook/useConfig";
import {UserCounter, Breakpoints, TopList, TopListItem} from '@octavius-rocks/ui';
import {useWordPressContents} from "../../hook/useWordPressContents";
import {
    useLiveBreakPointsCluster,
    useLiveContentIdByIndex,
    useLiveContentIds,
    useLiveCount,
} from '../../hook/useLiveData';
import {useStyles} from "./LiveUserRocks.styles";

const RealtimeContentItem = (
    {
        index, content = {}
    }
) => {
    const contentId = useLiveContentIdByIndex(index);
    const {
        value
    } = contentId
    const {
        title = contentId.key,
        url = "#",
    } = content

    return <TopListItem
        text={title}
        url={url}
        description={`${value} Zugriffe`}
    />
};

export default function LiveUserRocks({breakpointsCluster}) {

    const classes = useStyles()

    const [numberOfPosts, setNumberOfPosts] = useNumberOfItems(5, "livePosts");

    const count = useLiveCount();
    const content_ids = useLiveContentIds();
    const contents = useWordPressContents()
    const breakpoints = useLiveBreakPointsCluster(breakpointsCluster);

    return <div>
        <h2 className={classes.title}>Echtzeit</h2>
        <div className={classes.firstSection}>
            <div className={classes.liveCounter}>
                <UserCounter
                    headline="Aktuell"
                    subLine="aktive Nutzer auf der Seite"
                    count={count}
                />
            </div>
            <div className={classes.liveBreakpoints}>
                <Breakpoints
                    values={breakpoints.map(b => ({
                        ...b,
                        label: b.key,
                    }))}
                />
            </div>
        </div>
        <div className={classes.secondSection}>
            <TopList
                numberOfItems={numberOfPosts}
                changeable
                i18n={{
                    beforeInput: "Top",
                    afterInput: "Beiträge",
                }}
                onChange={(value) => setNumberOfPosts(parseInt(value))}
            >
                {content_ids.map((contentId, index) =>
                    <RealtimeContentItem
                        key={contentId.key}
                        index={index}
                        {...contentId}
                        content={contents[contentId.key]}
                    />
                )}
            </TopList>
        </div>
    </div>
};
